import { Injectable } from '@angular/core';
import * as global_var from '../global.variable';
import {Router} from '@angular/router';
import { map, timeout} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private http: HttpClient, private router: Router) {}

  getCountry(data: any = {}) {
    return this.http.post(global_var.apiUrl + 'getCountry', data
    ).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getUkCountries() {
    return this.http.post(global_var.apiUrl + 'getUkCountry', {}
    ).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getCurrency() {
    return this.http.post(global_var.apiUrl + 'getCurrency', {}
    ).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  saveSignup(data: any) {
    return this.http.post(global_var.apiUrl + 'signup',
    {data: data}
    ).pipe(
      timeout(300000),
      map((res: any) => {
        return res;
      })
    );
  }
}
